import { css } from '@emotion/react';
import { White } from '@constants/color';

export const container = css({
  width: '100%',
  flexDirection: 'row',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
});
export const timeText = css({
  fontWeight: 500,
  fontSize: 32,
  lineHeight: '41.6px',
  color: White.White10
});

export const microphoneWrapper = css({
  flex: 1,
  display: 'flex',
  justifyContent: 'flex-start'
});

export const timeTextWrapper = css({
  flex: 1,
  display: 'flex',
  justifyContent: 'center'
});

export const bottomRightContainer = css({
  display: 'flex',
  flex: 1,
  justifyContent: 'flex-end'
});
export const buttonContainer = css({
  width: '320px'
});
